import { render, staticRenderFns } from "./BusinessKpisView.vue?vue&type=template&id=0d202db4&"
import script from "./BusinessKpisView.vue?vue&type=script&lang=ts&"
export * from "./BusinessKpisView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports